import { USE_THIS_PAYMENT } from 'constants/checkoutButtons';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import styles from 'styles/components/checkout/caap/payment/paymentlist/continueButtonBottom.scss';

const ContinueButtonTop = componentParams => {
  const {
    canUseThisPayment,
    isFetchingCheckoutData,
    onUseThisPaymentClick,
    selectedPaymentNeedsConfirmation
  } = componentParams;

  if (selectedPaymentNeedsConfirmation) {
    return null;
  }

  return (
    <Row mobileOnly={true}>
      <RowSpan span="12">
        <button
          className={styles.checkoutPrimaryButton}
          disabled={!canUseThisPayment || isFetchingCheckoutData}
          id={`${USE_THIS_PAYMENT}-top`}
          onClick={onUseThisPaymentClick}
          type="button">
          Continue
        </button>
      </RowSpan>
    </Row>
  );
};

export default ContinueButtonTop;
